import React from 'react'
import { Loader, Row } from 'rsuite'

export default function LoaderProcessing({ textAlign = 'center', msg = 'ระบบกำลังประมวลผล...' }) {
  return (
    <Row style={{ textAlign: textAlign }}>
      <Loader size="lg" content={msg} vertical />
    </Row>
  )
}
